import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'grommet';
import { CircleAlert, FormClose, FormRefresh } from 'grommet-icons';

const ErrorNotice = ({
  message,
  messageColor,
  iconColor = null,
  backgroundColor,
  borderColor = null,
  showRefresh = false,
  handleDismiss = null,
  children = null,
}) => (
  <Box
    background={backgroundColor}
    border={borderColor && {
      color: borderColor, size: '1px', side: 'all', style: 'solid',
    }}
    round="10px"
    direction="column"
    align="start"
    justify="center"
    gap="0.4rem"
    pad="0.65rem 0.85rem"
  >
    <Box width="100%" direction="row" align="center" gap="0.5rem">
      <CircleAlert color={iconColor ?? messageColor} size="1.15rem" />
      <Text color={messageColor} weight={500} size="1rem">{message}</Text>
      {(showRefresh || handleDismiss) && (
        <Box flex direction="row" align="center" justify="end" gap="0.5rem">
          {showRefresh && (
            <Box
              direction="row"
              align="center"
              gap="0.25rem"
              style={{ cursor: 'pointer' }}
              onClick={() => window.location.reload()}
            >
              <Text color={messageColor} weight={600} size="0.9rem">
                Refresh
              </Text>
              <FormRefresh color={messageColor} size="1.1rem" />
            </Box>
          )}
          {handleDismiss && (
            <Box style={{ cursor: 'pointer' }} onClick={handleDismiss}>
              <FormClose color={messageColor} size="1.1rem" />
            </Box>
          )}
        </Box>
      )}
    </Box>
    {children}
  </Box>
);

ErrorNotice.propTypes = {
  message: PropTypes.string.isRequired,
  messageColor: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  borderColor: PropTypes.string,
  iconColor: PropTypes.string,
  showRefresh: PropTypes.bool,
  handleDismiss: PropTypes.func,
  children: PropTypes.node,
};

export default ErrorNotice;
